import { Controller } from "@hotwired/stimulus"

// Cajón de navegación para pantallas chicas.
// El diseño original no tenía menú móvil; este lo agrega.
export default class extends Controller {
  static targets = ["panel", "overlay", "openIcon", "closeIcon"]

  connect() {
    this.closeOnNavigation = () => this.close()
    document.addEventListener("turbo:before-visit", this.closeOnNavigation)
  }

  disconnect() {
    document.removeEventListener("turbo:before-visit", this.closeOnNavigation)
    this.#unlockScroll()
  }

  toggle() {
    this.#isOpen() ? this.close() : this.open()
  }

  open() {
    this.panelTarget.classList.remove("hidden")
    this.overlayTarget.classList.remove("hidden")
    this.openIconTarget.classList.add("hidden")
    this.closeIconTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
    // Deja el foco dentro del panel para navegación por teclado.
    this.panelTarget.querySelector("a, button")?.focus()
  }

  close() {
    this.panelTarget.classList.add("hidden")
    this.overlayTarget.classList.add("hidden")
    this.openIconTarget.classList.remove("hidden")
    this.closeIconTarget.classList.add("hidden")
    this.#unlockScroll()
  }

  closeOnEscape(event) {
    if (event.key === "Escape") this.close()
  }

  #isOpen() {
    return !this.panelTarget.classList.contains("hidden")
  }

  #unlockScroll() {
    document.body.classList.remove("overflow-hidden")
  }
}
